import MonacoEditor from '@monaco-editor/react';
import React from 'react';

interface SchemaMonacoEditorProps {
    value: string;
    onChange: (value: string | undefined) => void;
    height?: string;
}

const SchemaMonacoEditor: React.FC<SchemaMonacoEditorProps> = ({ 
    value, 
    onChange,
    height = "400px" 
}) => {
    return (
        <div style={{ border: '1px solid #d9d9d9', borderRadius: '2px' }}>
            <MonacoEditor
                height={height}
                language="json"
                theme="light"
                value={value}
                onChange={onChange}
                options={{
                    minimap: { enabled: false },
                    formatOnPaste: true,
                    formatOnType: true,
                    automaticLayout: true,
                }}
            />
        </div>
    );
};

export default SchemaMonacoEditor; 